export const ethnicityOptions = [
    { value: "2135-2", label: "Hispanic or Latino/ Spanish" },
    { value: "2155-0", label: "Central American" },
    { value: "2182-4", label: "Cuban" },
    { value: "2184-0", label: "Dominican" },
    { value: "2137-8", label: "Spaniard" },
    { value: "2165-9", label: "South American" },
    { value: "2180-8", label: "Puerto Rican" },
    { value: "2148-5", label: "Mexican" },
    { value: "2178-2", label: "Latin American/Latin, Latino" },
    { value: "2186-5", label: "Not Hispanic / Latino" },
    { value: "declined", label: "Declined" },
];

export const raceOptions = [
    { value: "2106-3", label: "White" },
    { value: "1074-4", label: "Spanish American Indian" },
    { value: "2054-5", label: "Black / African American" },
    { value: "2058-6", label: "African American" },
    { value: "2028-9", label: "Asian" },
    { value: "1002-5", label: "American Indian or Alaskan Native" },
    { value: "2076-8", label: "Native Hawaiian or Pacific Islander" },
    { value: "2110-5", label: "English" },
    { value: "declined", label: "Declined" },
];

export const languageOptions = [
    { value: "eng", label: "English" },
    { value: "declined", label: "Declined" },
];

export const genderOptions = [
    { value: "F", label: "Female" },
    { value: "M", label: "Male" },
];

export const emergencyRelationshipOptions = [
    { value: "CHILD", label: "CHILD" },
    { value: "COUSIN", label: "COUSIN" },
    { value: "FRIEND", label: "FRIEND" },
    { value: "GUARDIAN", label: "GUARDIAN" },
    { value: "OTHER", label: "OTHER" },
    { value: "PARENT", label: "PARENT" },
    { value: "SIBLING", label: "SIBLING" },
    { value: "SPOUSE", label: "SPOUSE" },
];

export const maritalOptions = [
    { value: "S", label: "Single" },
    { value: "M", label: "Married" },
    { value: "D", label: "Divorced" },
    { value: "W", label: "Widowed" },
    { value: "X", label: "Separated" },
    { value: "P", label: "Partner" },
    { value: "U", label: "Unknown" },
];


export const refractionsOptions = [
    { value: "true", label: "Yes, I do want a prescription for glasses and/or contacts." },
    { value: "false", label: "No, I do not want a prescription for glasses and/or contacts." }
];

export const imagingOptions = [
    { value: "Yes – I would like the Optos imaging performed today ($39.00).", label: "Yes – I would like the Optos imaging performed today ($39.00)." },
    { value: "No – I decline the Optos imaging and understand that using the Optomap greatly enhances my doctor's  ability to comprehensively examine my eyes. I understand that early detection of potentially threatening  disease is an important part of my thorough eye health evaluation. I consent to have my pupils dilated today.", label: "No – I decline the Optos imaging and understand that using the Optomap greatly enhances my dcotor's  ability to comprehensively examine my eyes. I understand that early detection of potentially threatening  disease is an important part of my thorough eye health evaluation. I consent to have my pupils dilated today." },
    { value: "I have read and understand the information and elect to refuse both dilation and Optos imaging against my doctor's recommendation.", label: "I have read and understand the information and elect to refuse both dilation and Optos imaging against my doctor's recommendation." }
];

export const payOptions = [
    { value: "You have no health insurance", label: "You have no health insurance" },
    { value: "You have health insurance, but you do NOT want your insurance billed and instead want to pay out of pocket", label: "You have health insurance, but you do NOT want your insurance billed and instead want to pay out of pocket" },
];

 
